import * as React from "react";
import { Button } from "@grandvisionhq/common";
const AddButton = (props) => /* @__PURE__ */ React.createElement(
  Button,
  {
    size: "custom",
    "data-t": "add-button",
    className: "add-button",
    variant: "ghost",
    color: "primary",
    ...props
  }
);
export {
  AddButton
};
//# sourceMappingURL=AddButton.js.map
